import { Stack } from '@mui/material';
import React from 'react';
import ChatsSideBarFixedHeader from './chats-side-bar-fixed-header';
import classes from './team-inbox.module.scss';
import WaChatLazyLoadingVirtuoso from './wa-chat-lazy-loading-virtuoso';

const ChatsSideBar = React.memo(() => {

  return (
    <Stack
      className={classes.chatContactsBarWrapper}
      sx={{
        position: 'relative',
      }}
    >
      <ChatsSideBarFixedHeader />

      <WaChatLazyLoadingVirtuoso />
    </Stack>
  );
});

export default ChatsSideBar;